import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

export const useFinancialIndicatorsBlockDiagrams = () => {
    //@ts-ignore
    const { financial_info, is_customer, information } = useSelector(
        //@ts-ignore
        (store) => store.dashboardReducer
    );
    const [maxValue, setMaxValue] = useState(0);

    useEffect(() => {
        if (financial_info) {
            const {
                current_period_customer_expenses,
                current_period_expenses,
                upcoming_period_customer_expenses,
                upcoming_period_expenses,
            } = financial_info;

            const max = Math.max(
                current_period_customer_expenses,
                current_period_expenses,
                upcoming_period_customer_expenses,
                upcoming_period_expenses
            );
            //@ts-ignore
            setMaxValue(numberFormatter.formatNumber(max));
        }
    }, [financial_info]);
    return { financial_info, maxValue, is_customer, is_archive: information.is_archive };
};
